<!-- src/components/ProfitCalculator/ProfitCalculator.vue -->
<template>
  <div class="profit-calculator">
    <h1>收益率计算器</h1>
    <div class="calculator-card">
      <el-form :model="form" label-width="120px" class="calculator-form">
        <el-form-item label="计算类型">
          <el-radio-group v-model="form.calcType" @change="resetForm">
            <el-radio label="target">计算达到目标收益所需参数</el-radio>
            <el-radio label="normal">计算当前收益率</el-radio>
          </el-radio-group>
        </el-form-item>

        <target-calculator
          v-if="form.calcType === 'target'"
          :target-profit="form.targetProfit"
          :cost-price="form.costPrice"
          @update:targetProfit="form.targetProfit = $event"
          @update:costPrice="form.costPrice = $event"
        />

        <normal-calculator
          v-else
          :sell-price="form.sellPrice"
          :cost-price2="form.costPrice2"
          @update:sellPrice="form.sellPrice = $event"
          @update:costPrice2="form.costPrice2 = $event"
        />

        <!-- 结果显示区域 -->
        <calculator-result
          v-if="form.calcType === 'target'"
          :results="targetResults"
        />

        <calculator-result
          v-else
          :results="normalResults"
        />
      </el-form>
    </div>
  </div>
</template>

<script>
import TargetCalculator from './TargetCalculator.vue'
import NormalCalculator from './NormalCalculator.vue'
import CalculatorResult from './CalculatorResult.vue'

export default {
  name: 'ProfitCalculator',
  components: {
    TargetCalculator,
    NormalCalculator,
    CalculatorResult
  },
  data() {
    return {
      form: {
        calcType: 'normal',
        targetProfit: 30000,
        costPrice: 10,
        costPrice2: 10,
        sellPrice: 15
      },
      targetResult: {
        sellPrice: 0,
        profitRate: 0
      },
      normalResult: {
        profit: 0,
        profitRate: 0
      }
    }
  },
  computed: {
    targetResults() {
      return [
        { label: '需要卖出价', value: this.targetResult.sellPrice, unit: '元' },
        { label: '收益率', value: this.targetResult.profitRate, unit: '%' },
         { label: '总收益金额', value: this.targetResult.profitRate*100000, unit: '元' }
      ];
    },
    normalResults() {
      return [
        { label: '收益金额', value: this.normalResult.profit, unit: '元' },
        { label: '收益率', value: this.normalResult.profitRate, unit: '%' },
        { label: '总收益金额', value: this.normalResult.profit*100000, unit: '元' }
      ];
    }
  },
  watch: {
    'form.targetProfit': 'calculateTarget',
    'form.costPrice': 'calculateTarget',
    'form.sellPrice': 'calculateNormal',
    'form.costPrice2': 'calculateNormal'
  },
  mounted() {
    this.calculateTarget();
    this.calculateNormal();
  },
  methods: {
    calculateTarget() {
      if (this.form.costPrice > 0) {
        const sellPrice = this.form.costPrice + (this.form.targetProfit * this.form.costPrice / 95);
        const profitRate = (this.form.targetProfit * this.form.costPrice / 95) / this.form.costPrice * 95;
        this.targetResult.sellPrice = sellPrice.toFixed(3);
        this.targetResult.profitRate = profitRate.toFixed(3);
      }
    },

    calculateNormal() {
      // 根据公式 收益率 = (卖出价-成本价)/成本价*95
      const profit = this.form.sellPrice - this.form.costPrice2;
      let profitRate = 0;

      if (this.form.costPrice2 > 0) {
        profitRate = (profit / this.form.costPrice2) * 95;
      }

      this.normalResult.profit = profit.toFixed(3);
      this.normalResult.profitRate = profitRate.toFixed(3);
    },

    resetForm() {
      // 切换计算类型时重置结果
      this.targetResult = { sellPrice: 0, profitRate: 0 };
      this.normalResult = { profit: 0, profitRate: 0 };
      this.$nextTick(() => {
        this.calculateTarget();
        this.calculateNormal();
      });
    }
  }
}
</script>

<style scoped>
.profit-calculator {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}

.calculator-card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 30px;
}

.calculator-form {
  margin-top: 20px;
}
</style>
